export default "__VITE_ASSET__0dc529e7__"